/**
 * Pass Eye — show/hide toggle for .lbfield password inputs (gestao).
 *
 * Safe to run multiple times (htmx/AJAX re-renders).
 *
 * @package Labead
 */

/**
 * Initialize password eye toggle for all unmanaged .lbfield-password inputs.
 */
export default function initPassEye() {
	document.querySelectorAll('.lbfield-password input').forEach(input => {
		if (input.dataset.lbPassEyeReady === '1') return;

		const inputType = String(input.getAttribute('type') || '').toLowerCase();
		if (inputType !== 'password') return;

		input.dataset.lbPassEyeReady = '1';

		const wrapper = document.createElement('div');
		wrapper.className = 'lbpass-container';

		input.parentNode.insertBefore(wrapper, input);
		wrapper.appendChild(input);

		input.classList.add('lbpass-input');

		const button = document.createElement('button');
		button.type = 'button';
		button.className = 'toggle-icon lw:inline-flex lw:items-center lw:justify-center lw:text-theme-muted lw:hover:opacity-75';
		button.setAttribute('aria-label', 'Mostrar senha');
		button.setAttribute('title', 'Mostrar senha');

		button.innerHTML = [
			'<i data-lucide="eye" class="lb-pass-eye-open lw:w-4 lw:h-4"></i>',
			'<i data-lucide="eye-off" class="lb-pass-eye-closed lw:w-4 lw:h-4 lw:hidden"></i>',
		].join('');

		button.addEventListener('click', () => {
			const isPassword = input.getAttribute('type') === 'password';
			input.setAttribute('type', isPassword ? 'text' : 'password');

			const openIcon = button.querySelector('.lb-pass-eye-open');
			const closedIcon = button.querySelector('.lb-pass-eye-closed');
			if (openIcon && closedIcon) {
				openIcon.classList.toggle('lw:hidden', isPassword);
				closedIcon.classList.toggle('lw:hidden', !isPassword);
			}

			button.setAttribute('aria-label', isPassword ? 'Ocultar senha' : 'Mostrar senha');
			button.setAttribute('title', isPassword ? 'Ocultar senha' : 'Mostrar senha');
		});

		wrapper.appendChild(button);
	});
}
